<template>
  <div class="bgm-container" @click="showDialog" @mouseleave="hideDialog">
    <svg-icon name="music_bg"></svg-icon>
    <div class="top-item-text">
      {{name || '添加背景音乐'}}
    </div>
    <svg-icon name="triangle" :class="{
      'rotate-180': visible,
      'rotate-0': !visible,
    }"></svg-icon>
    <BeautyGorgeousMusic v-show="visible" @selectedBgm="selectedBgm" :visible="visible"></BeautyGorgeousMusic>
  </div>
</template>

<script>
import BeautyGorgeousMusic from 'components/beauty-gorgeous-music.vue'

export default {
  name: 'bgm-container',
  components: {
    BeautyGorgeousMusic
  },
  data() {
    return {
      visible: false,
      name: '添加背景音乐'
    }
  },
  computed: {
    dubbingParams () {
      return this.$store.state.global.dubbingParams
    }
  },
  watch: {
    dubbingParams (val) {
      this.name = val.bgm_name
    },
  },
  mounted() {
    this.name = this.dubbingParams.bgm_name
  },
  methods: {
    selectedBgm (item) {
      this.name = item.bgm_name
      let dubbingParams = {...this.dubbingParams}
      dubbingParams.bgm_name = item.bgm_name
      dubbingParams.bgm_url = item.bgm_url
      this.$store.dispatch('global/setDubbingParams', dubbingParams)
      this.hideDialog()
    },
    showDialog() {
      this.visible = true
      this.$emit('showDialog')
    },
    hideDialog () {
      this.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.bgm-container {
  height: 68px;
  background: #FBFBFB;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  margin-right: 0;
  width: 270px;
  padding: 0 23px;
  cursor: pointer;
  .top-item-text {
    flex: 1;
    margin: 0 15px;
  }
  .svg-icon--music_bg {
    width: 50px;
    height: 50px;
  }
  .svg-icon--triangle {
    width: 17px;
    height: 10px;
  }
}
</style>
